import React, { useState, useEffect } from "react";
import "../../../../assets/styles/custom/components/dashboard/Crew.scss";
import {
  Dashboards,
  simformQuery,
  GetQualificationCert,
  GroundFormQuery,
  aircraftFormQuery,
  Qualificationwarning,
  DeleteMissingQ,
  InsertMissingQ,
  MissingQ,
} from "./Queries/DashboardQuery";
import firebase from "../../../../Firebase/firebase";
import "./CrewDashboard.scss";
import Popup1 from "./../popup1";
import moment from "moment";
import apollo_client from "../../../../apollo_client";
import Loading from "./../../../../assets/images/loading.gif";
const CrewDashboard = () => {
  const [QualificationRecord, setQualificationRecord] = useState([]);
  const [SimFormRecord, setSimFormRecord] = useState([]);
  const [GroundFormRecord, setGroundFormRecord] = useState([]);
  const [AircraftFormRecord, setAircraftFormRecord] = useState([]);
  const [MissingQRecord, setMissingQRecord] = useState([]);
  const [loading, setloading] = useState(false);
  const [dashboardDetails, setdashboardDetails] = useState({});
  const [popupToggle1, setpopupToggle1] = useState(false);
  const [Blankform, setBlankform] = useState("");
  const popup1 = (data) => {
    setpopupToggle1(!popupToggle1);
    setBlankform(data);
  };
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        setloading(true);
        let dashboardDet = await apollo_client.query({
          query: Dashboards,
          variables: {
            id: user.uid,
          },
        });
        console.log(dashboardDet.data.aatmsv4_crews[0]);
        setdashboardDetails(dashboardDet.data.aatmsv4_crews[0]);
        let qualifications = await apollo_client.query({
          query: GetQualificationCert,
          variables: {
            id: user.uid,
          },
        });
        console.log(
          "qualifications",
          qualifications.data.aatmsv4_qualifications
        );
        setQualificationRecord(qualifications.data.aatmsv4_qualifications);
        let simulatorrecords = await apollo_client.query({
          query: simformQuery,
          variables: {
            id: user.uid,
          },
        });
        console.log(simulatorrecords.data?.aatmsv4_simformrecords);
        setSimFormRecord(simulatorrecords.data?.aatmsv4_simformrecords);

        let groundFromrec = await apollo_client.query({
          query: GroundFormQuery,
          variables: {
            id: user.uid,
          },
        });
        console.log(groundFromrec.data.aatmsv4_groundforms);
        setGroundFormRecord(groundFromrec.data.aatmsv4_groundforms);

        let aircraftrec = await apollo_client.query({
          query: aircraftFormQuery,
          variables: {
            id: user.uid,
          },
        });
        console.log(aircraftrec.data.aatmsv4_airformrecords);
        setAircraftFormRecord(aircraftrec.data.aatmsv4_airformrecords);

        console.log(dashboardDetails.clienstid);
        let currentdate = moment().format("YYYY-MM-DD");
        let qualificationwar = await apollo_client.query({
          query: Qualificationwarning,
          variables: {
            clienstid: dashboardDetails.clienstid,
            date: currentdate,
            id: user.uid
          }
        });
        console.log("Qualifications", qualificationwar.data?.aatmsv4_qualifications)
        let qualificwarning = [];
        if (qualificationwar.data && qualificationwar.data.aatmsv4_qualifications !== undefined && qualificationwar.data.aatmsv4_qualifications.length > 0) {
          qualificationwar.data.aatmsv4_qualifications.forEach(warning => {
            if (warning.qualificationrecords.length === 0) {
              qualificwarning.push(warning)
            }
          });
        }
        setMissingQRecord(qualificwarning)


        setloading(false);
      } else {
        console.log("SIGNED OUT");
      }
    });
  }, []);

  if (loading) {
    return (
      <img
        style={{ padding: 100 }}
        src={loading ? Loading : null}
        height="50%"
        alt=""
        width="50%"
      />
    );
  }
  return (
    <div>
      <div className="category-title">Dashboard</div>
      <div className="crew-dashboard-cont">
        <div className="crew-dashboard-left">
          <div className="crew-dashboard-left--1">
            <div className="fleet-profile-image-container">
              <div className="fleet-title">
                {dashboardDetails.fleet?.aircraft}
              </div>
              <div className="category-container">
                <img alt="Profile" src={dashboardDetails.photo}></img>
              </div>
              <div className="fleet-profile-name">{dashboardDetails.name}</div>
              <div className="fleet-profile-designation">
                {dashboardDetails.rank?.rank}
              </div>
              <div className="fleet-profile-status">
                {dashboardDetails.active === true ? "Active" : "Disabled"}
              </div>
            </div>
          </div>
        </div>
        <div className=" crew-dashboard-middle employeebox">
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Airline</div>
            <div className="details">{dashboardDetails.fleet?.clientname}</div>
          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Fleet</div>
            <div className="details">{dashboardDetails.fleet?.aircraft}</div>
          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Rank</div>
            <div className="details">{dashboardDetails.rank?.rank}</div>
          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Name</div>
            <div className="details">{dashboardDetails.name}</div>
          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Employee Code</div>
            <div className="details">{dashboardDetails.ecode}</div>
          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Base</div>
            <div className="details">{dashboardDetails.airport?.airport}</div>
          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;License </div>
            <div className="details">{dashboardDetails.license}</div>
          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Phone Number</div>
            <div className="details">
              
                {dashboardDetails.phone1} &nbsp; &nbsp; {dashboardDetails.phone2}
              
            </div>
            {/* <div className="details">{dashboardDetails.phone2}</div> */}

          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Email ID</div>
            <div className="details">{dashboardDetails.email}</div>
          </div>
          <div className="employeebox__details">
            <div className="title">&#x2022; &nbsp;Date of Birth /Joining</div>
            <div className="details">
              {dashboardDetails.birthdate}
              &nbsp;&nbsp;&nbsp;
              {dashboardDetails.joiningdate}
            </div>
          </div>
          <div className="employeebox__details">
            <div className=" title">&#x2022; &nbsp;Address</div>
            <div className=" details"> {dashboardDetails.addresspmt}</div>
          </div>
          <div className="employeebox__details">
            <div className=" title">&#x2022; &nbsp;Training Manager(s)</div>
            <div className=" details">
              {dashboardDetails.manager?.managername}
            </div>
          </div>
        </div>
        <div className="crew-dashboard-right">
          <div className="message-from-chief">
            <div className="text-part">
              {dashboardDetails.client?.crewmessage}
            </div>
          </div>
        </div>
      </div>
      {MissingQRecord.length > 0 && (
        <div className="status-board">
          <div className="category-title">Important Todo's :</div>
          <div className="whiteboard">
            {MissingQRecord.map((records, index) => {
              return (
                records.qualificationrecords.length <= 0 && (
                  <div key={index} className="row">
                    <div className="col-lg-12">
                      <label className="textred tile blinking">
                        &rsaquo; Warning !! Missing or expired qualification, upload ASAP :  {records.qcode}
                        -||- {records.qualification} 
                      </label>
                    </div>
                  </div>
                )
              );
            })}
          </div>
        </div>
      )}

      <div className="status-board">
        {QualificationRecord.length > 0 && (
          <React.Fragment>
            <div className="category-title">Key Privileges :</div>
            <div className="board">
              <div className="tile-list">
                {QualificationRecord.map((records, index) => {
                  if (
                    records.banner &&
                    records.banner !== null &&
                    records.qualificationrecords.length > 0
                  ) {
                    let days =
                      moment(
                        new Date(records.qualificationrecords[0].validdate)
                      ).diff(moment(), "days") + 0;
                    return (
                      <li
                        key={index}
                        className={
                          days > 45
                            ? " green"
                            : days <= 45 && days >= 0
                              ? " yellow"
                              : " red"
                        }
                        onClick={() => {
                          popup1(records.qualificationrecords[0].document);
                        }}
                      >
                        {popupToggle1 === true ? (
                          <Popup1
                            setpopupToggle1={setpopupToggle1}
                            simulatorData={Blankform}
                          />
                        ) : null}
                        {records.qcode}
                      </li>
                    );
                  }
                })}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="status-board">
        {QualificationRecord.length > 0 && (
          <React.Fragment>
            <div className="category-title">Your License & Certificates :</div>
            <div className="board">
              <div className="tile-list">
                {QualificationRecord.map((records, index) => {
                  if (
                    records.banner === null &&
                    records.qualificationrecords.length > 0
                  ) {
                    let days =
                      moment(
                        new Date(records.qualificationrecords[0].validdate)
                      ).diff(moment(), "days") + 0;
                    return (
                      <li
                        key={index}
                        className={
                          days > 45
                            ? "  green"
                            : days <= 45 && days >= 0
                              ? " yellow"
                              : " red"
                        }
                        onClick={() => {
                          popup1(records.qualificationrecords[0].document);
                        }}
                      >
                        {popupToggle1 === true ? (
                          <Popup1
                            setpopupToggle1={setpopupToggle1}
                            simulatorData={Blankform}
                          />
                        ) : null}
                        {records.qcode}
                      </li>
                    );
                  }
                })}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="status-board">
        {GroundFormRecord.length > 0 && (
          <React.Fragment>
            <div className="category-title">Your Ground Qualifications :</div>
            <div className="board">
              <ul className="tile-list">
                {GroundFormRecord.map((records, index) => {
                  let days =
                    moment(new Date(records.validity)).diff(moment(), "days") +
                    1;
                  return (
                    <li
                      key={index}
                      className={
                        days > 45
                          ? "  green"
                          : days <= 45 && days >= 0
                            ? " yellow"
                            : " red"
                      }
                      onClick={() => {
                        popup1(records.blankform);
                      }}
                    >
                      {popupToggle1 === true ? (
                        <Popup1
                          setpopupToggle1={setpopupToggle1}
                          simulatorData={Blankform}
                        />
                      ) : null}
                      {records.groundformname}
                    </li>
                  );
                })}
              </ul>
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="status-board">
        {SimFormRecord && SimFormRecord.length > 0 && (
          <React.Fragment>
            <div className="category-title">
              Your Simulator Qualifications :
            </div>
            <div className="board">
              <ul className="tile-list">
                {SimFormRecord.map((records, index) => {
                  let days =
                    moment(new Date(records.validtill)).diff(moment(), "days") +
                    0;
                  return (
                    <li
                      key={index}
                      className={
                        days > 45
                          ? "  green"
                          : days <= 45 && days >= 0
                            ? " yellow"
                            : " red"
                      }
                      onClick={() => {
                        popup1(records.simrecord);
                      }}
                    >
                      {popupToggle1 === true ? (
                        <Popup1
                          setpopupToggle1={setpopupToggle1}
                          simulatorData={Blankform}
                        />
                      ) : null}
                      <span className="mr5">{records.date}</span>
                      <span className="mr5">{records.simformname}  </span>
                      <span className="mr5">{records.resulttext}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="status-board">
        {AircraftFormRecord.length > 0 && (
          <React.Fragment>
            <div className="category-title">Your Aircraft Qualifications :</div>
            <div className="board">
              <ul className="tile-list">
                {AircraftFormRecord.map((records, index) => {
                  if (records.validtill !== null) {
                    let days =
                      moment(new Date(records.validtill)).diff(
                        moment(),
                        "days"
                      ) + 0;
                    return (
                      <li
                        key={index}
                        className={
                          days > 45
                            ? "  green"
                            : days <= 45 && days >= 0
                              ? " yellow"
                              : " red"
                        }
                        onClick={() => {
                          popup1(records.airrecord);
                        }}
                      >
                        {popupToggle1 === true ? (
                          <Popup1
                            setpopupToggle1={setpopupToggle1}
                            simulatorData={Blankform}
                          />
                        ) : null}
                        {records.airformname}
                      </li>
                    );
                  }
                })}
              </ul>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default CrewDashboard;
